<template>
  <form :action="route" class="" role="form" method="POST">
    <div class="columns">
      <div class="column is-6">
        <div v-if="!is_invitation" :class="form.errors.has('is_corporate') ? 'has-error' : ''" class="field">
          <p class="control" style="text-align: justify;">
            <label class="checkbox">
              <input
                v-model="form.is_corporate"
                type="checkbox"
                name="is_corporate"
              />
              <span v-html="$t('registration.is_corporate')" />
            </label>
            <span
              v-if="form.errors.has('is_corporate')"
              class="help is-danger"
              v-html="form.errors.get('is_corporate')"
            />
          </p>
        </div>
        <div class="field">
          <p class="control has-icon has-icon-right">
            <input
              id="first_name"
              v-model="form.first_name"
              :class="form.errors.has('first_name') ? 'is-danger' : ''"
              :placeholder="$t('registration.first_name')"
              class="input is-medium"
              type="text"
              name="first_name"
            />
          </p>
          <p v-if="form.errors.has('first_name')" class="help is-danger">
            <i class="fa fa-warning" /> {{form.errors.get('first_name')}}
          </p>
        </div>
        <div class="field">
          <p class="control has-icon has-icon-right">
              <input
                  id="last_name"
                  v-model="form.last_name"
                  :class="form.errors.has('last_name') ? 'is-danger' : ''"
                  :placeholder="$t('registration.last_name')"
                  class="input is-medium"
                  type="text"
                  name="last_name"
              />
          </p>
          <p v-if="form.errors.has('last_name')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('last_name')}}
          </p>
        </div>
        <div class="field">
          <p class="control has-icon has-icon-right">
            <input
              id="email"
              v-model="form.email"
              :class="form.errors.has('email') ? 'is-danger' : ''"
              :placeholder="$t('registration.email')"
              :readonly="!!email"
              class="input is-medium"
              type="text"
              name="email"
            />
          </p>
          <p v-if="form.errors.has('email')" class="help is-danger">
            <i class="fa fa-warning" /> {{form.errors.get('email')}}
          </p>
        </div>

        <div class="field">
          <p class="control has-icon has-icon-right">
            <Password
              id="password"
              v-model="form.password"
              :default-class="
                form.errors.has('password')
                  ? 'input is-medium is-danger'
                  : 'input is-medium'
              "
              :placeholder="$t('registration.password')"
              :badge="false"
              :toggle="true"
              :secure-length="6"
            />
          </p>
          <p class="help is-small">
            Minimum 6 characters. Use at least one number and uppercase letter
            in your password
          </p>
          <p v-if="form.errors.has('password')" class="help is-danger">
            <i class="fa fa-warning" /> {{form.errors.get('password')}}
          </p>
        </div>

        <div class="field">
          <p class="control has-icon has-icon-right">
            <Password
              id="password_confirmation"
              v-model="form.password_confirmation"
              :default-class="
                form.errors.has('password_confirmation')
                  ? 'input is-medium is-danger'
                  : 'input is-medium'
              "
              :placeholder="$t('registration.password_confirm')"
              :badge="false"
              :toggle="true"
              :secure-length="6"
            />
          </p>
        </div>
      </div>
    </div>

    <div v-if="form.is_corporate && !is_invitation">
      <div class="columns" style="margin-bottom: -10px;">
        <div class="column is-6">
          <div class="field">
            <label for="company_name" class="label">
              {{$t('profile.company_name')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="company_name"
                v-model="form.company_name"
                :class="form.errors.has('company_name') ? 'is-danger' : ''"
                :placeholder="$t('profile.company_name')"
                class="input is-medium"
                type="text"
                name="company_name"
              />
            </p>
            <p v-if="form.errors.has('company_name')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('company_name')}}
            </p>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label for="company_code" class="label">
              {{$t('profile.company_code')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="company_code"
                v-model="form.company_code"
                :class="form.errors.has('company_code') ? 'is-danger' : ''"
                :placeholder="$t('profile.company_code')"
                class="input is-medium"
                type="text"
                name="company_code"
              />
            </p>
            <p v-if="form.errors.has('company_code')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('company_code')}}
            </p>
          </div>
        </div>
      </div>
      <div class="columns" style="margin-bottom: -10px;">
        <div class="column is-6">
          <div class="field">
            <label for="vat_number" class="label">
              {{$t('profile.vat_number')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="vat_number"
                v-model="form.vat_number"
                :class="form.errors.has('vat_number') ? 'is-danger' : ''"
                :placeholder="$t('profile.vat_number')"
                class="input is-medium"
                type="text"
                name="vat_number"
              />
            </p>
            <p v-if="form.errors.has('vat_number')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('vat_number')}}
            </p>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <country-select
              v-model="form.company_country"
              name="company_country"
              placeholder="Select country..."
              :has-errors="form.errors.has('company_country')"
            />
            <p v-if="form.errors.has('company_country')" class="help is-danger">
              <i class="fa fa-warning"></i> {{ form.errors.get('company_country') }}
            </p>
          </div>
        </div>
      </div>
      <div class="columns" style="margin-bottom: -10px;">
        <div class="column is-6">
          <div class="field">
            <label for="city" class="label">
              {{$t('profile.city')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="city"
                v-model="form.city"
                :class="form.errors.has('city') ? 'is-danger' : ''"
                :placeholder="$t('profile.city')"
                class="input is-medium"
                type="text"
                name="city"
              />
            </p>
            <p v-if="form.errors.has('city')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('city')}}
            </p>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label for="zip" class="label">
              {{$t('profile.zip')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="zip"
                v-model="form.zip"
                :class="form.errors.has('zip') ? 'is-danger' : ''"
                :placeholder="$t('profile.zip')"
                class="input is-medium"
                type="text"
                name="zip"
              />
            </p>
            <p v-if="form.errors.has('zip')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('zip')}}
            </p>
          </div>
        </div>
      </div>
      <div class="columns" style="margin-bottom: -10px;">
        <div class="column is-12">
          <div class="field">
            <label for="address" class="label">
              {{$t('profile.address')}}
            </label>
            <p class="control has-icon has-icon-right">
              <input
                id="address"
                v-model="form.address"
                :class="form.errors.has('address') ? 'is-danger' : ''"
                :placeholder="$t('profile.address')"
                class="input is-medium"
                type="text"
                name="address"
              />
            </p>
            <p v-if="form.errors.has('address')" class="help is-danger">
              <i class="fa fa-warning" /> {{form.errors.get('address')}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" style="margin-bottom: -10px;">
      <div class="column is-12">
        <div :class="form.errors.has('terms_and_conditions') ? 'has-error' : ''" class="field">
          <p class="control" style="text-align: justify;">
            <label class="checkbox">
              <input
                v-model="form.terms_and_conditions"
                type="checkbox"
                name="terms_and_conditions"
              />
              <span v-html="$t('registration.gdpr.terms_and_conditions')" />
            </label>
            <span
              v-if="form.errors.has('terms_and_conditions')"
              class="help is-danger"
              v-html="form.errors.get('terms_and_conditions')"
            />
          </p>
        </div>

        <div class="field">
          <p class="control" style="text-align: justify;">
            <label class="checkbox">
              <input
                v-model="form.newsletters"
                type="checkbox"
                name="newsletters"
              />
              <span
                v-html="$t('registration.gdpr.product_updates_and_offers')"
              />
            </label>
          </p>
        </div>
      </div>
    </div>

    <div class="field mt-2">
      <p class="control is-right">
        <button
          type="submit"
          class="button is-primary is-medium is-outlined is-fullwidth"
          @click.prevent="register()"
        >
          {{ $t('registration.button') }}
        </button>
      </p>
    </div>

    <p style="text-align: justify;">
      <em v-html="$t('registration.gdpr.note')" />
    </p>
  </form>
</template>

<script>
import Form from '../../helpers/Form/Form';

export default {
  name: 'Registration',

  props: {
    route: { type: String, required: true },
    redirect: { type: String, required: false, default: '' },
    is_invitation: { type: Boolean, default: false },
    email: { type: String, default: '' }
  },

  data() {
    return {
      form: new Form({
        nick: '',
        first_name: '',
        last_name: '',
        email: this.email,
        password: '',
        password_confirmation: '',
        type: 'student',
        terms_and_conditions: null,
        is_corporate: null,
        newsletters: null,
        company_name: null,
        company_code: null,
        vat_number: null,
        company_country: null,
        city: null,
        address: null,
        zip: null
      })
    };
  },

  computed: {
    isCompanyAccount() {
      return this.form.type === 'company';
    }
  },

  watch:{
    'form.is_corporate'(val) {
      if (val === true) {
        this.form.type = 'company';
      } else {
        this.form.type = 'student';
        this.form.company_name = null;
        this.form.company_code = null;
        this.form.vat_number = null;
        this.form.company_country = null;
        this.form.city = null;
        this.form.address = null;
        this.form.zip = null;
      }
    }
  },

  methods: {
    register() {
      const loader = this.$loading.show();
      this.form
        .post(this.route)
        .then(() => {
          location.href = this.redirect ? this.redirect : '/profile';
        })
        .catch(() => {
          error(this.$t('registration.flash_error'));
          loader.hide();
        });
    }
  }
};
</script>
